$xml-editor-modal-backdrop-background-color: 'rgba(230, 228, 228, 0.65)';
$xml-editor-background-color: '#687a88';
$xml-editor-border: '2px solid grey';

@mixin background-color() {
  background-color: #{$xml-editor-background-color};
}

.recipe-editor {
  .modal-backdrop {
    background: #{$xml-editor-modal-backdrop-background-color} !important;
    display: flex;
    .modal-dialog {
      width: 100%;
      margin: auto !important;
      .modal-content {
        .modal-header {
          @include background-color;
          color: white;
          text-align: center;
          padding-top: 5px;
          padding-bottom: 5px;
          border-bottom: 0;
        }
        .modal-footer {
          @include background-color;
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 0;

          .btn {
            margin: 0 10px;
            padding: 5px 12px;
          }
          .btn-primary {
            background-color: #006755;
            border-color: #006755;
          }
        }

        .modal-body {
          max-height: 470px;
          overflow: auto;
          table {
            width: 100%;
            border-bottom: #{$xml-editor-border};
            margin-bottom: 13px;

            th {
              border: #{$xml-editor-border};
              background-color: #d8d2d2;
            }

            td:first-child {
              font-style: italic;
              font-weight: 600;
            }
            td {
              border: 1px solid #c7c4c4;
              padding: 1px 5px;
              border-right: #{$xml-editor-border};
              border-left: #{$xml-editor-border};
              input {
                width: 100%;
                border: none;
                color: black;
                border-radius: 0;
                padding: 2px 5px !important;
              }

              select {
                background: transparent;
                border: none;
                width: 100%;
              }
            }

            @for $i from 1 to 6 {
              .p-#{$i * 20} {
                padding-left: $i * 12px;
              }
            }
          }
          .mouse-pointer {
            cursor: pointer;

          }
          .fa {
            font-size: 21px !important;
            color: #9a9292;
            padding-right: 2px;
          }

          .fa-caret-true:before {
            content: "\F0D7";
          }
          .fa-caret-false:before {
            content: "\F0DA";
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/xml-editor/inputFile.scss